import { legalDocumentPath } from '@/constants/legalDocuments';
import type { LegalDocument } from '@/services/legalService';

/**
 * Either a published document, or the built-in stand-in used while the admin
 * documents are not live — which carries its own absolute `href`.
 */
export type LegalLinkTarget = Pick<LegalDocument, 'key' | 'title'> & {
  href?: string;
};

interface LegalLinkProps {
  document: LegalLinkTarget;
  className?: string;
}

/**
 * A single legal document link. The label is the document's own name, so renaming
 * it in the admin panel renames it everywhere.
 *
 * Always opens in a new tab: these links sit inside the signup form, and
 * navigating in place would throw away whatever the user has already typed.
 */
export const LegalLink = ({ document, className }: LegalLinkProps) => (
  <a
    // An explicit href is the fallback target; otherwise the document has a page here.
    href={document.href ?? legalDocumentPath(document.key)}
    target='_blank'
    rel='noopener noreferrer'
    className={className}
  >
    {document.title}
  </a>
);
